import { graphql } from '../../generated';

export const CATEGORY_FRAGMENT = graphql(`
  fragment CategoryFragment on CategoryInterface {
    id
    name
    order
    internalName
    shop {
      id
      name
      slug
      domain
    }
    type
    parentCategoryId
  }
`);

export const SEARCH_CATEGORIES = graphql(`
  query SearchCategories($terms: [String!], $types: [String!], $shopId: String) {
    categories(terms: $terms, types: $types, shopId: $shopId) {
      nodes {
        ...CategoryFragment
        parentCategoryId
        parentCategory {
          name
          type
        }
      }
    }
  }
`);

export const GET_CATEGORIES = graphql(`
  query GetCategories($ids: [ID!]) {
    categories(ids: $ids) {
      nodes {
        ...CategoryFragment
      }
    }
  }
`);

export const GET_PRODUCT_CATEGORIES = graphql(`
  query GetProductCategories($id: ID!, $after: String) {
    product(id: $id) {
      id
      categoryProducts(after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            category {
              ...CategoryFragment
            }
            order
          }
        }
      }
    }
  }
`);
